import React from 'react';
import {Link} from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import Badge from "../../../../../Commun/Badge/Badge";
import Swal from "sweetalert2";

const ListeContracts = (props) => {
    const {
        contracts,
        postTerminateAssuranceTransitoire,
        query_terminate_assu_transitoire
    } = props;

    const handleClickInfoAssTransitoire = () => {
        Swal.fire({
            icon: '',
            title: '',
            text: 'Ce véhicule bénéficie des mêmes garanties et options que celles de votre nouveau véhicule, uniquement s\'il est mis en circulation pour des essais en vue de la vente et pour une durée maximale de 30 jours à compter du jour où l\'assurance a été reportée sur le nouveau véhicule.',
            showConfirmButton: true,
            confirmButtonText: 'Ok',
            showCloseButton: true
        });
    };

    const handleTerminateAssuranceTransitoire = (contractId) => {
        Swal.fire({
            title: 'Confirmation',
            text: 'Confirmez-vous avoir vendu votre ancien véhicule ? Cela mettra fin à l\'assurance transitoire.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Oui, je confirme',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                postTerminateAssuranceTransitoire({
                    query: _.replace(query_terminate_assu_transitoire, '{id}', contractId)
                });

                Swal.fire(
                    'Terminé !',
                    'Votre ancien véhicule n\'est plus couvert par l\'assurance transitoire.',
                    'success'
                );
            }
        });
    };

    return (
        <div>
            <div className={'mt-5'}>
                <h1 className={'fw-bold'}><Link to={'/'}><i className="bi bi-arrow-left-circle me-2" /></Link> Mes contrats</h1>
            </div>
            {
                contracts.map(c => (
                    <div className={'bloc-white'} key={c.id}>
                        <div>
                            <h4 className={'fw-bold text-primary-light d-inline-block'}>Contrat N°{c.numeroPolice}</h4> <Link to={`/mes-contrats/mon-contrat/${c.id}`} className={'float-right d-none d-sm-block'}>Voir le détail</Link>
                        </div>

                        <div className={'mt-4'}>
                            <div className="row">
                                <div className="col">
                                    <p className={'mb-1 fw-bold'}>Date d'effet</p>
                                    <p className={'m-0 text-secondary'}>{moment(c.situation.dateAffaireNouvelle).format('L')}</p>
                                </div>
                                <div className="col">
                                    <p className={'mb-1 fw-bold'}>Situation</p>
                                    <Badge status={_.capitalize(c.situation.statut)}/>
                                </div>
                            </div>

                            <hr/>

                            <div className="row">
                                { c.vehicule.marque && <div className="col">
                                    <p className={'mb-1 fw-bold'}>Véhicule</p>
                                    <p className={'m-0 text-secondary'}>{c.vehicule.marque}</p>
                                </div> }
                                { c.vehicule.immatriculation && <div className="col">
                                    <p className={'mb-1 fw-bold'}>Immatriculation</p>
                                    <p className={'m-0 text-secondary'}>{c.vehicule.immatriculation || '-'}</p>
                                </div> }
                            </div>
                        </div>
                        {(c.old_vehicule?.immatriculation && c.vehicule.vente_old_vehicule !== 'T' && moment(c.old_vehicule.date_fin_piece).isAfter(moment()) ) && <>
                            <div className={'mt-5'}>
                                <h5 className={'fw-bold text-primary-light d-inline-block'}>Véhicule assuré dans le cadre de l'assurance transitoire</h5>
                                <span
                                    onClick={handleClickInfoAssTransitoire}
                                    className="d-inline-block text-center bg-primary text-white rounded-circle"
                                    style={{
                                        cursor: 'pointer',
                                        width: '20px',
                                        height: '20px',
                                        lineHeight: '20px',
                                        marginLeft: '10px'
                                    }}
                                >
                                    ?
                                </span>
                            </div>

                            <div className={'mt-4'}>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-xs-12">
                                        <p className={'mb-1 fw-bold'}>Véhicule assuré</p>
                                        <p className={'m-0 text-secondary'}>
                                            {c.old_vehicule.marque} {c.old_vehicule.modele}
                                        </p>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-xs-12">
                                        <p className={'mb-1 fw-bold'}>Immatriculation</p>
                                        <p className={'m-0 text-secondary'}>
                                            {c.old_vehicule.immatriculation}
                                        </p>
                                    </div>
                                </div>
                                <hr/>
                                <div className="row">
                                    <div className="col-lg-3 col-md-3 col-xs-12">
                                        <p className={'mb-1 fw-bold'}>Date d'effet</p>
                                        <p className={'m-0 text-secondary'}>{moment(c.old_vehicule.date_effet_piece).format('L')}</p>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-xs-12">
                                        <p className={'mb-1 fw-bold'}>Date de fin</p>
                                        <p className={'m-0 text-secondary'}>{moment(c.old_vehicule.date_fin_piece).format('L')}</p>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-xs-12">
                                        <p className={'mb-1 fw-bold'}>Statut</p>
                                        <Badge status={'En cours'}/>
                                    </div>
                                </div>
                                <hr/>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-xs-12">
                                        <p className={'mb-1 fw-bold'}>Avez-vous vendu votre ancien véhicule ?</p>
                                        <a href="#" onClick={(e) => {
                                            e.preventDefault();
                                            handleTerminateAssuranceTransitoire(c.id);
                                        }}>
                                            Oui, je l'ai vendu
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </>}

                        <div className="text-center mt-4 d-sm-none d-block">
                            <Link to={`/mes-contrats/mon-contrat/${c.id}`}>Voir le détail</Link>
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

export default ListeContracts;